const brandPaymentMethods: string = import.meta.env.VITE_BRAND_PAYMENTS_METHODS ?? ''

const supportedPaymentMethods = [
  {
    title: 'mastercard',
    icon: '/icons/payments/mastercard.svg',
  },
  {
    title: 'kaspi',
    icon: '/icons/payments/kaspi.svg',
  },
  {
    title: 'visa',
    icon: '/icons/payments/visa.svg',
  },
]

export const PAYMENTS = {
  title: 'payment_systems',
  items: supportedPaymentMethods.filter((p) => brandPaymentMethods.includes(p.title)),
}
